// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var $$Date = require("../../common/types/Date.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var Hooks = require("../../../utils/Hooks.bs.js");
var Media = require("../../common/Media/Media.bs.js");
var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Scroll = require("../../common/Scroll/Scroll.bs.js");
var $$Promise = require("reason-promise/src/js/promise.bs.js");
var UTCDate = require("../../common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Particles = require("../../../uikit/reason/Styles/Particles.bs.js");
var ViewStack = require("../../common/ViewStack.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Chat__Jsx3 = require("../../../uikit/reason/molecules/Chat/Chat__Jsx3.bs.js");
var FeaturesV3 = require("../../featureFlipper/FeaturesV3.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var MediaQuery = require("../../common/Media/MediaQuery.bs.js");
var MenuButton = require("../../bindings/MenuButton.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Attachments = require("../../common/Attachments/Attachments.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Next__Atoms = require("../../next/Next__Atoms.bs.js");
var Next__Image = require("../../next/Next__Image.bs.js");
var Types__User = require("../../user/Types__User.bs.js");
var GraphqlTag = require("graphql-tag").default;
var ApolloClient = require("reason-apollo/src/ApolloClient.bs.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var NonEmptyList = require("../../common/types/NonEmptyList.bs.js");
var Theme__Color = require("../../common/Theme/Theme__Color.bs.js");
var Buttons__Jsx3 = require("../../../uikit/reason/atoms/Buttons/Buttons__Jsx3.bs.js");
var Belt_SortArray = require("rescript/lib/js/belt_SortArray.js");
var TANApolloHooks = require("../../utils/apollo/TANApolloHooks.bs.js");
var React$1 = require("linkifyjs/react");
var Js_null_undefined = require("rescript/lib/js/js_null_undefined.js");
var Types__Attachment = require("../../common/types/Types__Attachment.bs.js");
var MenuButton$1 = require("@reach/menu-button");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Theme__Color__Vars = require("../../common/Theme/Theme__Color__Vars.bs.js");
var Colors = require("uikit/styles/colors");
var Conversations__Types = require("../types/Conversations__Types.bs.js");
var Utils__AttachmentUrl = require("../../../utils/Utils__AttachmentUrl.bs.js");
var Conversations__GraphQL = require("../graphql/Conversations__GraphQL.bs.js");
var ConversationInput__Form = require("./ConversationInput__Form.bs.js");
var ConversationMessageArea = require("./ConversationMessageArea.bs.js");
var Conversations__Components = require("./Conversations__Components.bs.js");
var UseWindowSize = require("uikit/hooks/useWindowSize");
var Chat = require("uikit/molecules/Chat/Chat");
var UnsupportedAttachmentsDialog = require("../../common/Attachments/UnsupportedAttachmentsDialog.bs.js");
var ConversationInput__Attachments = require("./ConversationInput__Attachments.bs.js");
var ConversationNotAnonymousWarning = require("./ConversationNotAnonymousWarning.bs.js");

var nameButton = CssJs.style([
      CssJs.textAlign("left"),
      CssJs.hover([
            CssJs.cursor(CssJs.pointer),
            CssJs.textDecoration(CssJs.underline)
          ])
    ]);

var avatarButton = CssJs.style([
      CssJs.borderStyle("none"),
      CssJs.padding("zero"),
      CssJs.hover([CssJs.cursor(CssJs.pointer)])
    ]);

var imageGrid = CssJs.style([
      CssJs.maxWidth({
            NAME: "px",
            VAL: 400
          }),
      CssJs.width({
            NAME: "vw",
            VAL: 60
          }),
      CssJs.display("grid"),
      CssJs.gridGap({
            NAME: "px",
            VAL: 4
          }),
      CssJs.gridTemplateColumns([{
              NAME: "repeat",
              VAL: [
                {
                  NAME: "num",
                  VAL: 6
                },
                {
                  NAME: "fr",
                  VAL: 1
                }
              ]
            }])
    ]);

var largeImageGridItem = CssJs.style([
      CssJs.unsafe("gridColumn", "span 3"),
      CssJs.unsafe("gridRow", "span 3")
    ]);

var smallImageGridItem = CssJs.style([
      CssJs.unsafe("gridColumn", "span 2"),
      CssJs.unsafe("gridRow", "span 2")
    ]);

var image = CssJs.style([
      CssJs.maxWidth({
            NAME: "percent",
            VAL: 100
          }),
      CssJs.height("auto"),
      CssJs.borderRadius({
            NAME: "px",
            VAL: 6
          }),
      CssJs.objectFit("cover"),
      CssJs.transition(150, undefined, undefined, "opacity"),
      CssJs.hover([CssJs.opacity(0.8)])
    ]);

var file = CssJs.style([
      CssJs.maxWidth({
            NAME: "vw",
            VAL: 60
          }),
      Media.minWidthJs("sm")([CssJs.maxWidth({
                  NAME: "px",
                  VAL: 400
                })]),
      CssJs.backgroundColor(Theme__Color.alto),
      CssJs.padding2({
            NAME: "px",
            VAL: 6
          }, {
            NAME: "px",
            VAL: 10
          }),
      CssJs.borderRadius({
            NAME: "px",
            VAL: 4
          }),
      CssJs.transition(150, undefined, undefined, "background-color"),
      CssJs.hover([CssJs.backgroundColor(Theme__Color.gallery)])
    ]);

var fileTextOverflow = CssJs.style([
      CssJs.overflow("hidden"),
      CssJs.whiteSpace("nowrap"),
      CssJs.textOverflow("ellipsis")
    ]);

var link = CssJs.style([CssJs.display("grid")]);

var Styles = {
  nameButton: nameButton,
  avatarButton: avatarButton,
  imageGrid: imageGrid,
  largeImageGridItem: largeImageGridItem,
  smallImageGridItem: smallImageGridItem,
  image: image,
  file: file,
  fileTextOverflow: fileTextOverflow,
  link: link
};

function ChatWindow$ChatParticipantMenu(props) {
  var user = props.user;
  var firstName = Types__User.shortLabel(user);
  var phone = user.phone;
  return React.createElement(MenuButton$1.Menu, {
              children: null
            }, props.button, React.createElement(MenuButton.List.make, {
                  children: null
                }, React.createElement(MenuButton.Link.make, {
                      children: "View profile",
                      to_: "/agents/" + user.id
                    }), phone !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(MenuButton$1.MenuLink, {
                            children: "Call",
                            href: "tel:" + phone + ""
                          }), React.createElement(MenuButton$1.MenuLink, {
                            children: "Send a text",
                            href: "sms:" + phone + ""
                          })) : React.createElement(MenuButton$1.MenuItem, {
                        children: "No phone number for " + firstName + "",
                        onSelect: (function (prim) {
                            
                          }),
                        disabled: true
                      })));
}

var ChatParticipantMenu = {
  make: ChatWindow$ChatParticipantMenu
};

function ChatWindow$ConversationMessageImages$SingleImage(props) {
  var image$1 = props.image;
  return React.createElement("a", {
              href: Utils__AttachmentUrl.baseAttachmentUrl(image$1.key),
              target: "_blank"
            }, React.createElement("img", {
                  className: image,
                  src: Utils__AttachmentUrl.makeAttachmentUrl(400, undefined, undefined, undefined, undefined, undefined, image$1.key)
                }));
}

var SingleImage = {
  make: ChatWindow$ConversationMessageImages$SingleImage
};

function ChatWindow$ConversationMessageImages$OneOfSeveralImages(props) {
  var size = props.size;
  var image$1 = props.image;
  var size$1 = size !== undefined ? size : "small";
  return React.createElement("div", {
              className: size$1 === "small" ? smallImageGridItem : largeImageGridItem
            }, React.createElement("a", {
                  className: link,
                  href: Utils__AttachmentUrl.baseAttachmentUrl(image$1.key),
                  target: "_blank"
                }, JsxPPXReactSupport.createElementWithKey(image$1.key, Next__Image.make, {
                      src: Utils__AttachmentUrl.makeAttachmentUrl(200, 200, true, undefined, undefined, undefined, image$1.key),
                      width: 200,
                      height: 200,
                      unoptimized: true,
                      alt: "",
                      className: image
                    })));
}

var OneOfSeveralImages = {
  make: ChatWindow$ConversationMessageImages$OneOfSeveralImages
};

function ChatWindow$ConversationMessageImages(props) {
  var images = props.images;
  if (!images[1]) {
    return React.createElement(ChatWindow$ConversationMessageImages$SingleImage, {
                image: images[0]
              });
  }
  var images$1 = NonEmptyList.toArray(images);
  var numImages = images$1.length;
  if (numImages % 3 !== 2) {
    return React.createElement("div", {
                className: imageGrid
              }, Belt_Array.mapWithIndex(images$1, (function (i, image) {
                      return JsxPPXReactSupport.createElementWithKey(String(i), ChatWindow$ConversationMessageImages$OneOfSeveralImages, {
                                  image: image
                                });
                    })));
  }
  var firstTwo = Belt_Array.slice(images$1, 0, 2);
  var rest = Belt_Array.sliceToEnd(images$1, 2);
  return React.createElement("div", {
              className: imageGrid
            }, Belt_Array.mapWithIndex(firstTwo, (function (i, image) {
                    return JsxPPXReactSupport.createElementWithKey(String(i), ChatWindow$ConversationMessageImages$OneOfSeveralImages, {
                                image: image,
                                size: "large"
                              });
                  })), Belt_Array.mapWithIndex(rest, (function (i, image) {
                    return JsxPPXReactSupport.createElementWithKey(String(i + 2 | 0), ChatWindow$ConversationMessageImages$OneOfSeveralImages, {
                                image: image
                              });
                  })));
}

var ConversationMessageImages = {
  SingleImage: SingleImage,
  OneOfSeveralImages: OneOfSeveralImages,
  make: ChatWindow$ConversationMessageImages
};

function ChatWindow$ConversationMessageFiles(props) {
  return React.createElement(React.Fragment, undefined, Belt_Array.map(NonEmptyList.toArray(props.files), (function (file$1) {
                    return React.createElement("div", {
                                key: file$1.id,
                                className: file
                              }, React.createElement("a", {
                                    download: file$1.fileName,
                                    href: Utils.baseAttachmentUrl(file$1.key),
                                    target: "_blank"
                                  }, React.createElement(ViewStack.make, {
                                        space: "xs",
                                        alignItems: "center",
                                        flexDirection: "row",
                                        children: Caml_option.some(null)
                                      }, React.createElement(Icon__Jsx3.make, {
                                            icon: /* File */35,
                                            size: 20,
                                            color: Theme__Color.mineShaft
                                          }), React.createElement(Text__Jsx3.make, {
                                            fontWeight: "bold",
                                            color: Colors.mineShaft,
                                            className: fileTextOverflow,
                                            children: file$1.fileName
                                          }))));
                  })));
}

var ConversationMessageFiles = {
  make: ChatWindow$ConversationMessageFiles
};

function cancelledAvatar(name) {
  return React.createElement(Chat__Jsx3.ChatAvatar.make, {
              src: AvatarSrcUrl.place_holder,
              name: name,
              overlayIcon: /* Unavailable */72,
              iconColor: Theme__Color__Vars.crimson
            });
}

function ChatWindow$ConversationMessage(props) {
  var currentUser = props.currentUser;
  var message = props.message;
  var isIncoming = !Conversations__Types.Message.senderIsUser(message, currentUser.id);
  var messageStatusEnabled = FeaturesV3.useFeatureFlipper("ConversationMessageStatus") === "on";
  var messageStatus = messageStatusEnabled && !isIncoming ? Belt_List.getBy(message.status, (function (status) {
            var match = status.participant;
            if (match) {
              return match._0.id !== currentUser.id;
            } else {
              return true;
            }
          })) : undefined;
  var user = message.sender;
  var tmp;
  if (user) {
    var user$1 = user._0;
    tmp = React.createElement(ChatWindow$ChatParticipantMenu, {
          user: user$1,
          button: React.createElement(MenuButton.LinkButton.make, {
                className: nameButton,
                children: Types__User.label(user$1)
              })
        });
  } else {
    tmp = null;
  }
  var user$2 = message.sender;
  var tmp$1;
  if (user$2) {
    var user$3 = user$2._0;
    var match = user$3.membershipStatus;
    tmp$1 = isIncoming ? (
        match === "TERMINATED" ? Caml_option.some(cancelledAvatar(Types__User.label(user$3))) : Caml_option.some(React.createElement(ChatWindow$ChatParticipantMenu, {
                    user: user$3,
                    button: React.createElement(MenuButton.Button.make, {
                          className: avatarButton,
                          children: React.createElement(Chat__Jsx3.ChatAvatar.make, {
                                src: Types__User.avatarURL(undefined, undefined, user$3),
                                name: Types__User.label(user$3)
                              })
                        })
                  }))
      ) : undefined;
  } else {
    tmp$1 = Caml_option.some(React.createElement(Chat__Jsx3.ChatAvatar.make, {
              src: AvatarSrcUrl.place_holder,
              name: "A TAN User"
            }));
  }
  var tmp$2;
  if (messageStatus !== undefined) {
    var deliveredAt = messageStatus.deliveredAt;
    var readAt = messageStatus.readAt;
    tmp$2 = readAt !== undefined ? "Read " + DateFns.format(UTCDate.toUnzonedDate(Caml_option.valFromOption(readAt)), "p") : (
        deliveredAt !== undefined ? "Delivered " + DateFns.format(UTCDate.toUnzonedDate(Caml_option.valFromOption(deliveredAt)), "p") : DateFns.format(UTCDate.toUnzonedDate(message.sentAt), "p")
      );
  } else {
    tmp$2 = DateFns.format(UTCDate.toUnzonedDate(message.sentAt), "p");
  }
  var text = message.text;
  var tmp$3;
  tmp$3 = text !== undefined && text !== "" ? React.createElement(React$1, {
          children: text
        }) : null;
  var images = message.images;
  var files = message.files;
  return React.createElement(Chat.Message, {
              isIncoming: isIncoming,
              senderName: Caml_option.some(tmp),
              senderAvatar: tmp$1,
              status: tmp$2,
              text: Caml_option.some(tmp$3),
              images: Caml_option.some(images !== undefined ? React.createElement(ChatWindow$ConversationMessageImages, {
                          images: images
                        }) : null),
              files: Caml_option.some(files !== undefined ? React.createElement(ChatWindow$ConversationMessageFiles, {
                          files: files
                        }) : null)
            });
}

var ConversationMessage = {
  cancelledAvatar: cancelledAvatar,
  make: ChatWindow$ConversationMessage
};

function ChatWindow$PropertyBroadcastEvent(props) {
  return React.createElement(Chat.Message, {
              isIncoming: true,
              senderAvatar: Caml_option.some(React.createElement(View__Jsx3.make, {
                        mr: {
                          NAME: "px",
                          VAL: 10
                        },
                        children: Caml_option.some(React.createElement(Icon__Jsx3.make, {
                                  icon: /* MegaphoneAlt */48,
                                  size: 30
                                }))
                      })),
              text: Caml_option.some(React.createElement(ViewStack.make, {
                        space: "sm",
                        children: Caml_option.some(null)
                      }, React.createElement("div", undefined, "The property was broadcast"), React.createElement(Next__Atoms.Link.make, {
                            href: "/properties/" + props.context.property.id,
                            children: "Click here to view the property page"
                          })))
            });
}

var PropertyBroadcastEvent = {
  make: ChatWindow$PropertyBroadcastEvent
};

function ChatWindow$BuyerNeedBroadcastEvent(props) {
  return React.createElement(Chat.Message, {
              isIncoming: true,
              senderAvatar: Caml_option.some(React.createElement(View__Jsx3.make, {
                        mr: {
                          NAME: "px",
                          VAL: 10
                        },
                        children: Caml_option.some(React.createElement(Icon__Jsx3.make, {
                                  icon: /* MegaphoneAlt */48,
                                  size: 30
                                }))
                      })),
              text: Caml_option.some(React.createElement(ViewStack.make, {
                        space: "sm",
                        children: Caml_option.some(null)
                      }, React.createElement("div", undefined, "The buyer need was broadcast"), React.createElement(Next__Atoms.Link.make, {
                            href: "/client_needs/" + props.context.buyerNeed.id,
                            children: "Click here to view the buyer need page"
                          })))
            });
}

var BuyerNeedBroadcastEvent = {
  make: ChatWindow$BuyerNeedBroadcastEvent
};

function ChatWindow$MessagesDivider(props) {
  var date = props.date;
  return React.createElement(Chat.DayDivider, {
              children: Caml_option.some((
                    DateFns.isSameDay(UTCDate.toUnzonedDate(date), $$Date.now(undefined)) ? "Today, " : ""
                  ) + DateFns.format(UTCDate.toUnzonedDate(date), "MM/dd/yyyy"))
            });
}

var MessagesDivider = {
  make: ChatWindow$MessagesDivider
};

function ChatWindow$MessagesContainer(props) {
  var tmp = {
    height: "auto",
    overflow: "auto"
  };
  if (props.maxHeight !== undefined) {
    tmp.maxHeight = props.maxHeight;
  }
  return React.createElement("div", {
              ref: props.forwardRef,
              style: tmp
            }, props.children);
}

var MessagesContainer = {
  make: ChatWindow$MessagesContainer
};

function getDate(x) {
  if (x.TAG === /* Message */0) {
    return x._0.sentAt;
  } else {
    return x._0.timestamp;
  }
}

function compareByTime(x, y) {
  return Caml.float_compare(UTCDate.toUnzonedDate(getDate(x)).getTime(), UTCDate.toUnzonedDate(getDate(y)).getTime());
}

function groupSortedElementsByDay(elements) {
  if (!elements) {
    return /* [] */0;
  }
  var head = elements.hd;
  var param = Belt_List.reduce(elements.tl, [
        {
          date: getDate(head),
          elements: {
            hd: head,
            tl: /* [] */0
          }
        },
        /* [] */0
      ], (function (param, e) {
          var finishedBundles = param[1];
          var currentBundle = param[0];
          if (DateFns.isSameDay(UTCDate.toUnzonedDate(getDate(e)), UTCDate.toUnzonedDate(currentBundle.date))) {
            return [
                    {
                      date: currentBundle.date,
                      elements: Belt_List.concat(currentBundle.elements, {
                            hd: e,
                            tl: /* [] */0
                          })
                    },
                    finishedBundles
                  ];
          } else {
            return [
                    {
                      date: getDate(e),
                      elements: {
                        hd: e,
                        tl: /* [] */0
                      }
                    },
                    Belt_List.concat(finishedBundles, {
                          hd: currentBundle,
                          tl: /* [] */0
                        })
                  ];
          }
        }));
  return Belt_List.concat(param[1], {
              hd: param[0],
              tl: /* [] */0
            });
}

function group(messages, events) {
  var list = Belt_List.concat(Belt_List.map(messages, (function (m) {
              return {
                      TAG: /* Message */0,
                      _0: m
                    };
            })), Belt_List.map(events, (function (e) {
              return {
                      TAG: /* Event */1,
                      _0: e
                    };
            })));
  return groupSortedElementsByDay(Belt_List.fromArray(Belt_SortArray.stableSortBy(Belt_List.toArray(list), compareByTime)));
}

function ChatWindow$MessagesAndEvents(props) {
  var currentUser = props.currentUser;
  var conversation = props.conversation;
  return Belt_List.toArray(Belt_List.mapWithIndex(group(conversation.messages, conversation.events), (function (i, param) {
                    return JsxPPXReactSupport.createElementWithKey(String(i), View__Jsx3.make, {
                                mb: {
                                  NAME: "px",
                                  VAL: 30
                                },
                                children: Caml_option.some(JsxPPXReactSupport.createElementVariadicWithKey(String(i), ViewStack.make, {
                                          space: {
                                            NAME: "px",
                                            VAL: 20
                                          },
                                          children: Caml_option.some(null)
                                        }, [
                                          React.createElement(ChatWindow$MessagesDivider, {
                                                date: param.date
                                              }),
                                          Belt_List.toArray(Belt_List.map(param.elements, (function (element) {
                                                      var match = conversation.context;
                                                      if (element.TAG === /* Message */0) {
                                                        var message = element._0;
                                                        return JsxPPXReactSupport.createElementWithKey(message.id, ChatWindow$ConversationMessage, {
                                                                    message: message,
                                                                    currentUser: currentUser
                                                                  });
                                                      }
                                                      var match$1 = element._0;
                                                      var id = match$1.id;
                                                      if (match$1.eventType) {
                                                        if (match !== undefined && match.TAG === /* PublicBuyerNeed */2) {
                                                          return JsxPPXReactSupport.createElementWithKey(id, ChatWindow$BuyerNeedBroadcastEvent, {
                                                                      context: match._0
                                                                    });
                                                        } else {
                                                          return null;
                                                        }
                                                      } else if (match !== undefined && match.TAG === /* PublicProperty */0) {
                                                        return JsxPPXReactSupport.createElementWithKey(id, ChatWindow$PropertyBroadcastEvent, {
                                                                    context: match._0
                                                                  });
                                                      } else {
                                                        return null;
                                                      }
                                                    })))
                                        ]))
                              });
                  })));
}

var MessagesAndEvents = {
  getDate: getDate,
  compareByTime: compareByTime,
  groupSortedElementsByDay: groupSortedElementsByDay,
  group: group,
  make: ChatWindow$MessagesAndEvents
};

function ChatWindow$MessagesWindow(props) {
  var conversation = props.conversation;
  var windowSize = UseWindowSize.useWindowSize();
  var match = Hooks.useComponentSize(undefined, undefined);
  var minHeight = MediaQuery.useMediaQuery({
        TAG: /* MinWidth */1,
        _0: Particles.Breakpoint.md
      }) ? 480 : 1000;
  var availableHeight = Math.max(Belt_Option.mapWithDefault(match[1], minHeight, (function (d) {
              return windowSize.height - d.offsetTop - 226;
            })), minHeight);
  return React.createElement("div", {
              key: Conversations__Types.Conversation.idToString(conversation.id),
              ref: Caml_option.some(match[0])
            }, React.createElement(ChatWindow$MessagesContainer, {
                  maxHeight: String(availableHeight | 0) + "px",
                  forwardRef: props.forwardRef,
                  children: React.createElement(ChatWindow$MessagesAndEvents, {
                        conversation: conversation,
                        currentUser: props.currentUser
                      })
                }));
}

var MessagesWindow = {
  make: ChatWindow$MessagesWindow
};

var $$let = Conversations__GraphQL.ConversationMessagesQuery.GQL;

var ReadQuery = ApolloClient.ReadQuery({
      query: $$let.query,
      parse: $$let.parse
    });

function ChatWindow$ConversationMessageInput(props) {
  var focusInputOnMount = props.focusInputOnMount;
  var onCreateConversationSuccess = props.onCreateConversationSuccess;
  var onNewMessageSuccess = props.onNewMessageSuccess;
  var currentUser = props.currentUser;
  var conversation = props.conversation;
  var id = conversation.id;
  var tmp;
  if (id.TAG === /* Existing */0) {
    var partial_arg = id._0;
    tmp = (function (param, param$1) {
        var query = Curry._2(Conversations__GraphQL.ConversationMessagesQuery.GQL.make, partial_arg, undefined);
        var toReadQueryOptions = function (result) {
          return {
                  query: GraphqlTag(result.query),
                  variables: Js_null_undefined.fromOption(Caml_option.some(result.variables))
                };
        };
        var readQueryOptions = toReadQueryOptions(query);
        var val;
        var val$1;
        try {
          val = Belt_Option.flatMap(Belt_Option.map(Caml_option.nullable_to_opt(param.readQuery(readQueryOptions)), (function (prim) {
                      return prim;
                    })), (function (q) {
                  return q.conversation;
                }));
          val$1 = Belt_Option.flatMap(param$1.data, (function (data) {
                  return data.replyToConversation.message;
                }));
        }
        catch (exn){
          return ;
        }
        if (val === undefined) {
          return ;
        }
        if (val$1 === undefined) {
          return ;
        }
        var conversation = Caml_option.valFromOption(val);
        var updatedConversation = {
          __typename: "Conversation",
          id: conversation.id,
          messages: Belt_Array.concat(conversation.messages, [val$1])
        };
        var updatedQuery = {
          conversation: updatedConversation
        };
        return Curry._4(Conversations__GraphQL.ConversationMessagesQuery.Write.make, param, Caml_option.some(query.variables), updatedQuery, undefined);
      });
  } else {
    tmp = (function (param, param$1) {
        
      });
  }
  var match = TANApolloHooks.useMutation(undefined, undefined, undefined, undefined, tmp, undefined, Conversations__GraphQL.ReplyToConversationMutation.GQL.definition);
  var replyMutate = match[0];
  var match$1 = TANApolloHooks.useMutation(undefined, undefined, undefined, undefined, (function (client, mutationResult) {
          var initiatedConversation = Belt_Option.flatMap(mutationResult.data, (function (data) {
                  return data.initiateConversation.conversation;
                }));
          if (initiatedConversation === undefined) {
            return ;
          }
          var initiatedConversation$1 = Caml_option.valFromOption(initiatedConversation);
          var query = Curry._2(Conversations__GraphQL.ConversationQuery.GQL.make, initiatedConversation$1.id, undefined);
          Curry._4(Conversations__GraphQL.ConversationQuery.Write.make, client, Caml_option.some(query.variables), Curry._1(Conversations__GraphQL.ConversationQuery.Write.makeQueryResponse, initiatedConversation$1), undefined);
        }), undefined, Conversations__GraphQL.InitiateConversationMutation.GQL.definition);
  var initiateConversationMutate = match$1[0];
  var isLoading = match[2].loading || match$1[2].loading;
  var fireMutation = function (param) {
    var text = param.text;
    var match = Belt_Array.partition(param.attachments, Types__Attachment.isImage);
    var files = match[1];
    var images = match[0];
    var id = conversation.id;
    if (id.TAG === /* Existing */0) {
      var variables = Conversations__GraphQL.ReplyToConversationMutation.makeVariables(id._0, text, images, files, undefined);
      return $$Promise.map($$Promise.mapOk(Curry._6(replyMutate, Caml_option.some(variables), undefined, undefined, undefined, Caml_option.some(Conversations__GraphQL.ReplyToConversationMutation.makeOptimisticResponse(currentUser, text, images, files)), undefined), (function (param) {
                        return param[1];
                      })), (function (x) {
                    if (x.TAG !== /* Ok */0) {
                      return {
                              TAG: /* Error */1,
                              _0: {
                                NAME: "NETWORK_ERROR",
                                VAL: x._0
                              }
                            };
                    }
                    var match = x._0;
                    var response = match.data;
                    if (response !== undefined) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                NAME: "Replied",
                                VAL: Caml_option.valFromOption(response)
                              }
                            };
                    }
                    var e = match.errors;
                    if (e !== undefined) {
                      return {
                              TAG: /* Error */1,
                              _0: {
                                NAME: "GRAPHQL_ERRORS",
                                VAL: e
                              }
                            };
                    } else {
                      return {
                              TAG: /* Error */1,
                              _0: "NO_DATA"
                            };
                    }
                  }));
    }
    var variables$1 = Conversations__GraphQL.InitiateConversationMutation.makeVariables(id._1, id._0, "PRIVATE", Belt_Option.mapWithDefault(conversation.context, false, (function (c) {
                return Conversations__Types.Context.isAnonymousMatch(c);
              })), text, images, files, undefined);
    return $$Promise.map($$Promise.mapOk(Curry._6(initiateConversationMutate, Caml_option.some(variables$1), undefined, undefined, undefined, undefined, undefined), (function (param) {
                      return param[1];
                    })), (function (x) {
                  if (x.TAG !== /* Ok */0) {
                    return {
                            TAG: /* Error */1,
                            _0: {
                              NAME: "NETWORK_ERROR",
                              VAL: x._0
                            }
                          };
                  }
                  var match = x._0;
                  var response = match.data;
                  if (response !== undefined) {
                    var conversationId = Belt_Option.map(Caml_option.valFromOption(response).initiateConversation.conversation, (function (conversastion) {
                            return conversastion.id;
                          }));
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              NAME: "InitiatedConversation",
                              VAL: conversationId
                            }
                          };
                  }
                  var e = match.errors;
                  if (e !== undefined) {
                    return {
                            TAG: /* Error */1,
                            _0: {
                              NAME: "GRAPHQL_ERRORS",
                              VAL: e
                            }
                          };
                  } else {
                    return {
                            TAG: /* Error */1,
                            _0: "NO_DATA"
                          };
                  }
                }));
  };
  var inputRef = React.useRef(null);
  React.useEffect((function () {
          if (focusInputOnMount) {
            Belt_Option.map(Caml_option.nullable_to_opt(inputRef.current), (function (el) {
                    return el.focus();
                  }));
          }
          
        }), []);
  var clearAttachments = React.useRef(undefined);
  var form = ConversationInput__Form.useForm({
        text: "",
        attachments: [],
        visibility: /* Private */0
      }, (function (state, param) {
          var reset = param.reset;
          $$Promise.getOk(fireMutation(state), (function (x) {
                  if (x.NAME === "Replied") {
                    Curry._1(onNewMessageSuccess, undefined);
                    Curry._1(reset, undefined);
                    var f = clearAttachments.current;
                    if (f !== undefined) {
                      return Curry._1(f, undefined);
                    } else {
                      return ;
                    }
                  }
                  var id = x.VAL;
                  if (id !== undefined) {
                    setTimeout((function (param) {
                            Curry._1(onCreateConversationSuccess, id);
                          }), 100);
                    return ;
                  }
                  
                }));
        }));
  var match$2 = React.useState(function () {
        return [];
      });
  var setUnsupportedFiles = match$2[1];
  var attachments$p = Attachments.useAttachments((function (attachments) {
          Curry._2(form.updateAttachments, (function (input, attachments) {
                  return {
                          text: input.text,
                          attachments: attachments,
                          visibility: input.visibility
                        };
                }), Belt_List.toArray(attachments));
        }), Belt_List.fromArray(form.input.attachments), (function (files) {
          Curry._1(setUnsupportedFiles, (function (param) {
                  return files;
                }));
        }));
  React.useEffect((function () {
          clearAttachments.current = attachments$p.clearAll;
        }), []);
  var submitDisabled = isLoading || !Curry._1(form.valid, undefined);
  var attachmentsEnabled = FeaturesV3.useFeatureFlipper("ConversationAttachments") === "on";
  var match$3 = React.useState(function () {
        return false;
      });
  var setInputIsFocused = match$3[1];
  var match$4 = conversation.id;
  var match$5 = conversation.visibility;
  var tmp$1;
  tmp$1 = isLoading ? "Posting..." : (
      match$4.TAG === /* Existing */0 ? (
          match$5 === "PUBLIC" ? "Reply Publicly" : "Reply"
        ) : (
          match$5 === "PUBLIC" ? "Message Publicly" : "Message Privately"
        )
    );
  var sendMessageButton = React.createElement(Buttons__Jsx3.PrimaryButton.make, {
        onClick: (function (param) {
            Curry._1(setInputIsFocused, (function (param) {
                    return false;
                  }));
            Curry._1(form.submit, undefined);
          }),
        disabled: submitDisabled,
        children: Caml_option.some(tmp$1)
      });
  var match$6 = attachments$p.attachments;
  return React.createElement(React.Fragment, undefined, React.createElement(UnsupportedAttachmentsDialog.make, {
                  files: match$2[0],
                  onDismiss: (function (param) {
                      Curry._1(setUnsupportedFiles, (function (param) {
                              return [];
                            }));
                    })
                }), React.createElement(View__Jsx3.make, {
                  pb: "lg",
                  px: "md",
                  children: Caml_option.some(React.createElement(ConversationNotAnonymousWarning.ConditionalWarning.make, {
                            conversation: conversation
                          }))
                }), React.createElement(ConversationMessageArea.make, {
                  isFocused: match$3[0],
                  maxHeight: {
                    NAME: "rem",
                    VAL: 6
                  },
                  inputRef: inputRef,
                  text: form.input.text,
                  onChangeText: (function (text) {
                      Curry._2(form.updateText, (function (input, text) {
                              return {
                                      text: text,
                                      attachments: input.attachments,
                                      visibility: input.visibility
                                    };
                            }), text);
                    }),
                  textInputDisabled: isLoading,
                  onFocus: (function (param) {
                      Curry._1(setInputIsFocused, (function (param) {
                              return true;
                            }));
                    }),
                  onBlur: (function (param) {
                      Curry._1(setInputIsFocused, (function (param) {
                              return false;
                            }));
                    }),
                  onKeyDown: (function (e) {
                      if (e.key === "Enter" && e.metaKey && Curry._1(form.valid, undefined)) {
                        return Curry._1(form.submit, undefined);
                      }
                      
                    }),
                  attachments: Caml_option.some(attachmentsEnabled && match$6.length !== 0 ? React.createElement("div", {
                              className: CssJs.style([CssJs.paddingTop({
                                          NAME: "px",
                                          VAL: 4
                                        })])
                            }, React.createElement(ConversationInput__Attachments.make, {
                                  uploads: match$6,
                                  onDeleteAttachment: attachments$p.delete
                                })) : null),
                  buttons: Caml_option.some(attachmentsEnabled ? React.createElement(ViewStack.make, {
                              justifyContent: "spaceBetween",
                              flexDirection: "row",
                              children: Caml_option.some(null)
                            }, React.createElement(ConversationInput__Attachments.AddButton.make, {
                                  onAddAttachment: attachments$p.add
                                }), React.createElement(ViewStack.make, {
                                  space: "xs",
                                  alignItems: "center",
                                  justifyContent: "flexEnd",
                                  flexDirection: "row",
                                  children: Caml_option.some(sendMessageButton)
                                })) : React.createElement(ViewStack.make, {
                              alignItems: "center",
                              justifyContent: "flexEnd",
                              flexDirection: "row",
                              children: Caml_option.some(sendMessageButton)
                            }))
                }));
}

var ConversationMessageInput = {
  ConversationMessageForm: undefined,
  ReadQuery: ReadQuery,
  make: ChatWindow$ConversationMessageInput
};

function ChatWindow(props) {
  var readOnly = props.readOnly;
  var focusInputOnMount = props.focusInputOnMount;
  var onNewMessageSuccess = props.onNewMessageSuccess;
  var onCreateConversationSuccess = props.onCreateConversationSuccess;
  var theme = props.theme;
  var currentUser = props.currentUser;
  var conversation = props.conversation;
  var theme$1 = theme !== undefined ? theme : Chat__Jsx3.ChatTheme.primaryTheme;
  var onCreateConversationSuccess$1 = onCreateConversationSuccess !== undefined ? onCreateConversationSuccess : (function (prim) {
        
      });
  var onNewMessageSuccess$1 = onNewMessageSuccess !== undefined ? onNewMessageSuccess : (function (prim) {
        
      });
  var focusInputOnMount$1 = focusInputOnMount !== undefined ? focusInputOnMount : false;
  var readOnly$1 = readOnly !== undefined ? readOnly : false;
  var markAsRead = Conversations__GraphQL.MarkConversationAsReadMutation.use(undefined);
  var messagesReadElementRef = React.useRef(undefined);
  var messagesListRef = React.useRef(undefined);
  var scrollMessagesToBottom = function (param) {
    var current = messagesListRef.current;
    if (current === undefined) {
      return ;
    }
    var current$1 = Caml_option.valFromOption(current);
    current$1.scrollTop = current$1.scrollHeight;
  };
  var markAsRead$1 = function (conversation) {
    var match = conversation.id;
    var match$1 = messagesReadElementRef.current;
    var match$2 = Utils.List.last(conversation.messages);
    if (match.TAG === /* Existing */0 && match$1 !== undefined && match$2 !== undefined && Scroll.isElementInView(Caml_option.valFromOption(match$1)) && Conversations__Types.Conversation.countUnread(currentUser.id, conversation.messages) > 0) {
      return Curry._2(markAsRead, match._0, match$2.id);
    }
    
  };
  Hooks.useEventListenerOnDocument(true, (function (param) {
          markAsRead$1(conversation);
        }), "scroll");
  React.useLayoutEffect((function () {
          scrollMessagesToBottom(undefined);
        }), [conversation]);
  React.useEffect((function () {
          markAsRead$1(conversation);
        }), [conversation]);
  return React.createElement(Chat__Jsx3.ChatWindow.make, {
              theme: theme$1,
              children: Caml_option.some(null)
            }, React.createElement(ChatWindow$MessagesWindow, {
                  forwardRef: Caml_option.some(function (e) {
                        Utils.React.setCurrentRef(messagesListRef, (e == null) ? undefined : Caml_option.some(e));
                      }),
                  conversation: conversation,
                  currentUser: currentUser
                }), React.createElement("span", {
                  ref: Caml_option.some(function (e) {
                        Utils.React.setCurrentRef(messagesReadElementRef, (e == null) ? undefined : Caml_option.some(e));
                      })
                }), readOnly$1 ? React.createElement(Conversations__Components.DeactivatedConversationWarning.make, {
                    participants: conversation.participants
                  }) : React.createElement(ChatWindow$ConversationMessageInput, {
                    conversation: conversation,
                    currentUser: currentUser,
                    onNewMessageSuccess: (function (param) {
                        Curry._1(onNewMessageSuccess$1, undefined);
                        scrollMessagesToBottom(undefined);
                      }),
                    onCreateConversationSuccess: onCreateConversationSuccess$1,
                    focusInputOnMount: focusInputOnMount$1
                  }));
}

var Chat$1;

var View;

var $$Text;

var Form;

var Buttons;

var Conversation;

var make = ChatWindow;

exports.Chat = Chat$1;
exports.View = View;
exports.$$Text = $$Text;
exports.Form = Form;
exports.Buttons = Buttons;
exports.Conversation = Conversation;
exports.Styles = Styles;
exports.ChatParticipantMenu = ChatParticipantMenu;
exports.ConversationMessageImages = ConversationMessageImages;
exports.ConversationMessageFiles = ConversationMessageFiles;
exports.ConversationMessage = ConversationMessage;
exports.PropertyBroadcastEvent = PropertyBroadcastEvent;
exports.BuyerNeedBroadcastEvent = BuyerNeedBroadcastEvent;
exports.MessagesDivider = MessagesDivider;
exports.MessagesContainer = MessagesContainer;
exports.MessagesAndEvents = MessagesAndEvents;
exports.MessagesWindow = MessagesWindow;
exports.ConversationMessageInput = ConversationMessageInput;
exports.make = make;
/* nameButton Not a pure module */
